import { render, staticRenderFns } from "./YSelect.vue?vue&type=template&id=578b579c&scoped=true&lang=pug&"
import script from "./YSelect.vue?vue&type=script&lang=js&"
export * from "./YSelect.vue?vue&type=script&lang=js&"
import style0 from "./YSelect.vue?vue&type=style&index=0&id=578b579c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578b579c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
